import React, { Component } from 'react';
import logo from './img/dirad_logo.png';
var ReactSuperSelect = require('react-super-select')

export class Dme extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            locations: [],
            error: false,
            errorBg: 0,
            step: 0,
			paNumber:  (Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString()),
	
			validDiags:['E7200','37200','E7201','37201','E7202','37202','E7204','37204','E7209','37209','E700','3700','E701','3701','E7020','37020','E7021','37021','E7029','37029','E7030','37030','E70310','370310','E70311','370311','E70318','370318','E70319','370319','E70320','370320','E70321','370321','E70328','370328','E70329','370329','E70330','370330','E70331','370331','E70338','370338','E70339','370339','E7039','37039','E705','3705','E708','3708','E709','3709','E710','3710','E71110','371110','E71111','371111','E71118','371118','E71120','371120','E71121','371121','E71128','371128','E7119','37119','E712','3712','E7210','37210','E7211','37211','E7212','37212','E7219','37219','E7040','37040','E7041','37041','E7049','37049','E7220','37220','E7221','37221','E7222','37222','E7223','37223','E7229','37229','E724','3724','E71120','371120','E723','3723','E7250','37250','E7251','37251','E7259','37259','E728','3728','E7203','37203','E728','3728','E729','3729','E7400','37400','E7401','37401','E7402','37402','E7403','37403','E7404','37404','E7409','37409','E744','3744','E7420','37420','E7421','37421','E7429','37429','E7410','37410','E7411','37411','E7412','37412','E7419','37419','E730','3730','E731','3731','E738','3738','E739','3739','E7431','37431','E7439','37439','E748','3748','E7252','37252','E7253','37253','E744','3744','E748','3748','E771','3771','E740','3740','E780','3780','E781','3781','E782','3782','E783','3783','E784','3784','E785','3785','E786','3786','E881','3881','E7521','37521','E7522','37522','E75240','375240','E75241','375241','E75242','375242','E75243','375243','E75248','375248','E75249','375249','E753','3753','E770','3770','E771','3771','E778','3778','E779','3779','E7130','37130','E755','3755','E7879','37879','E7881','37881','E7889','37889','E882','3882','E8889','38889','E756','3756','E7870','37870','E789','3789','E8801','38801','E8809','38809','E8809','38809','E83110','383110','E83111','383111','E83118','383118','E83119','383119','E8310','38310','E8319','38319','E832','3832','E8300','38300','E8301','38301','E8309','38309','E8340','38340','E8341','38341','E8342','38342','E8349','38349','E8330','38330','E8331','38331','E8332','38332','E8339','38339','E8350','38350','E8351','38351','E8352','38352','E201','3201','E8359','38359','E8381','38381','E8389','38389','E839','3839','E870','3870','E871','3871','E872','3872','E873','3873','E874','3874','E8349','38349','E8330','38330','E840','3840','E8419','38419','E848','3848','E800','3800','E801','3801','E8020','38020','E8021','38021','E8029','38029','E790','3790','E791','3791','E792','3792','E798','3798','E799','3799','E859','3859','E850','3850','E851','3851','E852','3852','E853','3853','E854','3854','E858','3858','E804','3804','E805','3805','E806','3806','E807','3807','E7601','37601','E7602','37602','E7603','37603','E761','3761','E76210','376210','E76211','376211','E76219','376219','E7622','37622','E7629','37629','E763','3763','E768','3768','E769','3769','E8881','38881','E7141','37141','E7142','37142','E7143','37143','E7140','37140','E71440','371440','E71448','371448','E71310','371310','E71311','371311','E71312','371312','E71313','371313','E71314','371314','E71318','371318','E7132','37132','E7150','37150','E71510','371510','E71511','371511','E71518','371518','E71520','371520','E71521','371521','E71522','371522','E71528','371528','E71529','371529','E7153','37153','E71540','371540','E71541','371541','E71542','371542','E71548','371548','E8840','38840','E8841','38841','E8842','38842','E8849','38849','E7139','37139','E803','3803','E8889','38889','E889','3889','E889','3889','E7523','37523','E7525','37525','E7529','37529','E7500','37500','E7501','37501','E7502','37502','E7509','37509','E7510','37510','E7511','37511','E7519','37519','E754','3754','E7871','37871','E7872','37872','K210','5210','K219','5219','K900','5900','Z91011','991011','Z91013','991013','Z91018','991018','Z9102','99102'],
            mobile: "",
            code: ""
        };
    }


    next = (e) => {
        switch (this.state.step) {
            case 0:
                this.setState({ loading: true }, async () => {
                    var response = await fetch(window.location.origin + '/twofa?mobile=' + this.state.mobile)
                    if (!response.ok) {
                        this.setState({ step: 0, loading: false, error: await response.text() })
                    } else {
                        this.setState({ step: 1, loading: false, error: null })
                    }
                });
                break
            case 1:
                this.setState({ loading: true }, async () => {
                    var response = await fetch(window.location.origin + '/twofaVerify?mobile=' + this.state.mobile + '&code=' + this.state.code)
                    if (!response.ok) {
                        this.setState({ step: 1, loading: false, error: await response.text() })
                    } else {
                        this.setState({ step: 2, loading: false,  error: null })
                    }
                });
                break
			 case 2:
				if(!this.state.role){
					this.setState({ loading: false, error: 'Please select a role.' })
                    return false
				}
				this.setState({ step: 3, loading: false, error: null })
                break
            case 3:
                if (!this.state.npi || this.state.npi.length != 10 || /\D/gm.test(this.state.npi)) {
                    this.setState({ loading: false, error: 'That is not a valid Provider Identification Number. Provider Identification Numbers consist of 10 digits. This is not the same as your MMIS or license number.' })
                    return false
                }
				 if (!this.state.mobile || this.state.mobile.length != 10 || /\D/gm.test(this.state.mobile) ) {
                    this.setState({ loading: false, error: 'Please provide your 10 digit telephone number, including area code.' })
                    return false
                }
                if (!this.state.cin || !(/\D\D.{5}\D/gm.test(this.state.cin))) {
                    this.setState({ loading: false, error: 'The CIN you entered isn’t valid. Please check your records and try again. It should be 8 characters long, with a letter in the first, second, and eighth position.' })
                    return false
                }
                if (!this.state.dob || this.state.dob.length != 10 || new Date().getTime() < new Date(new Date(this.state.dob.substr(6), (this.state.dob.substr(0,2) -1),  this.state.dob.substr(3,2)))) {
                    this.setState({ loading: false, error: 'Enter the patient’s eight-digit date of birth as a two-digit month, two-digit day and four-digit year.' })
                    return false
                }
                if (!this.state.height || this.state.height.toString().length < 2 || this.state.height.toString().length > 3 ||  /\D/gm.test(this.state.height)) {
                    this.setState({ loading: false, error: 'Please enter a valid height in inches, no letters or symbols.' })
                    return false
                }
				if (!this.state.weight || this.state.weight.toString().length < 1 || this.state.weight.toString().length > 3 ||  /\D/gm.test(this.state.weight)) {
                    this.setState({ loading: false, error: 'Please enter a valid weight in pounds, no letters or symbols.' })
                    return false
                }
				if(this.state.imd == 'Yes'){
					if (!this.state.diagnosis || this.state.validDiags.indexOf(this.state.diagnosis) < 0) {
						this.setState({ loading: false, error: 'That is not a valid Diagnosis Code for this patient.' })
						return false
					}
				}
                
				 if (!this.state.calories || this.state.calories > 2000 || /\D/gm.test(this.state.calories)) {
                    this.setState({ loading: false, error: 'Please enter a valid number of calories, no letters or symbols.' })
                    return false
                }
				
				if (!this.state.refills || ['0','1','2','3','4','5'].indexOf(this.state.refills) < 0) {
                    this.setState({ loading: false, error: 'Please enter a valid number of refills, from 0-5.' })
                    return false
                }

                this.setState({ step: 4, loading: false, error: null, paNumber: (Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString() + Math.floor(Math.random() * 10).toString()) })
                break
            default:
                break
        }
    }

    checkEnter = (e) => {
        if (e.keyCode === 13) {
            this.next();
        }
		
    }
	startOver = (e) => {
		var newState = JSON.parse(JSON.stringify(this.state))
		 newState.admin = ''
		 newState.calories = ''
		 newState.cin = ''
		 newState.diagnosis = ''
		 newState.dob = ''
		 newState.height  = ''
		 newState.imd = ''
		 newState.paNumber  = ''
		 newState.refills = ''
		 newState.weight = ''
		newState.step = 3
		newState.error = false

		this.setState(newState )
	}
    inputCode = (e) => {
        this.setState({error: false, code: e.currentTarget.value.replace(/\D/gm, '').substr(0, 8) })
    }
    inputInfo = (field) => (e) => {
        var newState = JSON.parse(JSON.stringify(this.state))
        newState[field] = e.currentTarget.value
		newState.error = false
        this.setState(newState )
    }
    inputNumber = (field) => (e) => {
        var newState = JSON.parse(JSON.stringify(this.state))
        newState[field] = e.currentTarget.value ? e.currentTarget.value.replace(/\D/gm, '').substr(0, 10) : ''
		newState.error = false
        this.setState(newState)
    }
    selectLocation = (location) => {
        console.log(location)
        if (location) {
            var newState = JSON.parse(JSON.stringify(this.state.info))
            newState.Location = location.map((loc) => { return loc.name })
            console.log(newState.Location)
            this.setState({ info: newState })
        }
    }
	
	selectAction = (action) => {
		var newState = JSON.parse(JSON.stringify(this.state))
        if (action) {
            newState.action = action.name 
        } else {
			delete newState.action
		}
		newState.error = false
		this.setState( newState )
    }
    input = (field) => (e) => {
        var newState = {}
        newState[field] = e.currentTarget.value
		newState.error = false
        this.setState(newState)
    }
	selectRole = (role) => {
		var newState = JSON.parse(JSON.stringify(this.state))
        if (role) {
            newState.role = role.name 
        } else {
			delete newState.role
		}
		newState.error = false
		this.setState( newState )
    }
	
	selectAdmin= (admin) => {
		var newState = JSON.parse(JSON.stringify(this.state))
        if (admin) {
            newState.admin = admin.name 
        } else {
			delete newState.admin
		}
		newState.error = false
		this.setState( newState )
    }
	selectIMD= (imd) => {
		var newState = JSON.parse(JSON.stringify(this.state))
        if (imd) {
            newState.imd = imd.name 
        } else {
			delete newState.imd
		}
		newState.error = false
		this.setState( newState )
    }
	
	inputDate  = (field) => (e) => {
        var newState = {}
		var array = e.currentTarget.value.match(/\d/gm)
		if(array != null) {
			if(array.length > 1 && (array.length > 2 || e.currentTarget.value.length > this.state[field].length)){
				array.splice(2,0,'/')
			}
			if(array.length > 4  && (array.length > 5 || e.currentTarget.value.length > this.state[field].length)){
				array.splice(5,0,'/')
			}
			
			newState[field] = array.join('')
		} else {
			newState[field] = ''
		}
        newState.error = false
        this.setState(newState)
    }
	
    async componentWillMount() {
        var response = await fetch(window.location.origin + '/locations')
        if (response.ok) {
            this.setState({ locations: await response.json() })
        }
    }
    componentWillReceiveProps(nextProps) {
        if (this.state.loading) {
            this.setState({ loading: false, errorBg: 1 });
        }
        setTimeout(function () {
            this.setState({ errorBg: 0 });
        }.bind(this), 1000)
    }
	help = () => {
		this.setState({step: 'h'})
	}
	cancelHelp = () => {
		this.setState({step: 2})
	}
    render() {
        if (this.state.step == 0) {
            return (
                <div className="App">
                    <div className="backdrop"></div>
                    <div className="loginBox" onKeyUp={this.checkEnter}>
                        <img src={logo} className="App-logo" alt="logo" />

                        <div className="snazzyInputBox" style={{ padding: '10px 0px' }}>
                            <input className="textInput" type="text" required value={this.state.mobile} onChange={this.input('mobile')} ></input>
                            <span className="inputBar"></span>
                            <label className="textLabel">Enter a 10 Digit Mobile Number</label>
                        </div>

                        <div style={{ position: 'relative', padding: '1px', margin: '0px auto' }}>
                            {this.state.error ?
                                <div className="error" style={{ marginBottom: '20px', backgroundColor: 'rgba(144,48,112,' + this.state.errorBg + ')' }}>{this.state.error}</div>
                                : ''}

                            {this.state.loading ?
                                <div className="loader"></div>
                                :
                                <div className="button" onClick={this.next}>Send SMS</div>
                            }
                        </div>
                    </div>
                </div>
            )
        } else if (this.state.step == 1) {
            return (
                <div className="App">
                    <div className="backdrop"></div>
                    <div className="loginBox" onKeyUp={this.checkEnter}>
                        <img src={logo} className="App-logo" alt="logo" />
                        <div style={{ lineHeight: '30px' }}>An SMS has been sent to {this.state.mobile} <br /> Please enter the confirmation code below.</div>

                        <div className="snazzyInputBox" style={{ width: '200px', padding: '10px 0px' }}>
                            <input style={{ textAlign: 'center' }} className="textInput" type="text" required value={this.state.code} onChange={this.inputCode} ></input>
                            <span className="inputBar"></span>
                            <label className="textLabel">Code</label>
                        </div>

                        <div style={{ position: 'relative', padding: '1px', margin: '0px auto' }}>
                            {this.state.error ?
                                <div className="error" style={{ backgroundColor: 'rgba(144,48,112,' + this.state.errorBg + ')' }}>{this.state.error}</div>
                                : ''}

                            {this.state.loading ?
                                <div className="loader"></div>
                                :
                                <div className="button" onClick={this.next}>Confirm Code</div>
                            }
                        </div>
                    </div>
                </div>
            )
        } else if (this.state.step == 2) {
			 return (
                <div className="App">
                    <div className="backdrop"></div>
                    <div className="loginBox" style={{ maxWidth: '90vw', maxHeight: '80vh', overflow: 'auto' }} onKeyUp={this.checkEnter}>
                        <img src={logo} className="App-logo" alt="logo" />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', overflow: 'visible' }}>
                            <div style={{ textAlign: 'left', flex: '1 0 95%' }}>Please note that only a prescriber, an employee of the prescriber or an employee under the supervision of the prescriber can request an authorization.</div>
						</div>
						<br/>
						<div style={{ textAlign: 'left', flex: '1 0 95%' }}>Please indicate your role.</div>
						<ReactSuperSelect onChange={this.selectRole} clearable={false} closeOnSelectedOptionClick={false} dataSource={[{id: 'Physician or Physician’s Assistant', name: 'Physician or Physician’s Assistant'}, {id: 'Nurse Practitioner', name: 'Nurse Practitioner'}, {id: 'Nurse Midwife', name: 'Nurse Midwife'}, {id: 'Dispensing an Enteral Formula', name: 'Dispensing an Enteral Formula'}, {id: 'Dentist', name: 'Dentist'}]} />
						<br/>
						<div onClick={this.help}style={{ cursor:'pointer', textAlign: 'left', flex: '1 0 95%' }}>For the Medicaid enteral formula coverage criteria, click here. </div>
						<br/>
                        <div style={{ position: 'relative', padding: '1px', margin: '0px auto' }}>
                            {this.state.error ?
                                <div className="error" style={{ backgroundColor: 'rgba(144,48,112,' + this.state.errorBg + ')' }}>{this.state.error}</div>
                                : ''}

                            {this.state.loading ?
                                <div className="loader"></div>
                                :
                                <div className="button" onClick={this.next}>Submit Selection</div>
                            }
                        </div>
                    </div>
                </div>
            ) 
		} else if (this.state.step == 'h') {
			 return (
                <div className="App">
                    <div className="backdrop"></div>
                    <div className="loginBox" style={{ maxWidth: '90vw', maxHeight: '80vh', overflow: 'auto' }} onKeyUp={this.checkEnter}>
                        <img src={logo} className="App-logo" alt="logo" />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', overflow: 'visible' }}>

                            <div style={{ margin:'15px', textAlign: 'left', flex: '1 0 95%' }}>Enteral nutritional therapy is only covered by Medicaid as an integral component of a documented medical treatment plan ordered in writing by an authorized prescriber. There must be a documented diagnosis showing that caloric and dietary nutrients from food cannot be absorbed or metabolized. This must be substantiated in the patient's medical record by documented physical findings or laboratory data.</div>
			
							<div style={{ margin:'15px', textAlign: 'left', flex: '1 0 95%' }}>Enteral nutritional therapy is not covered as a supplement of daily protein-caloric intake when there is not documented medical necessity or as a convenient food substitute.</div>
						
						</div>
						
                        <div style={{ position: 'relative', padding: '1px', margin: '0px auto' }}>
                            

                            {this.state.loading ?
                                <div className="loader"></div>
                                :
                                <div className="button" onClick={this.cancelHelp}>Okay</div>
                            }
                        </div>
                    </div>
                </div>
            ) 
		}else if (this.state.step == 3) {
            return (
                <div className="App">
                    <div className="backdrop"></div>
                    <div className="loginBox" style={{ maxWidth: '90vw', maxHeight: '80vh', overflow: 'auto' }} onKeyUp={this.checkEnter}>
                        <img src={logo} className="App-logo" alt="logo" />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', overflow: 'visible' }}>
                            <div style={{ textAlign: 'left', flex: '1 0 95%', textAlign:'center' }}>Select Your Desired Action</div>
								
							<ReactSuperSelect onChange={this.selectAction} initialValue={{name: this.state.action, id: this.state.action}} closeOnSelectedOptionClick={false}  placeholder="Action" style={{ flex: '1 0 150px', margin: '0px' }} dataSource={[{id: 'Request PA', name: 'Request PA' },{id: 'Cancel PA', name: 'Cancel PA' }]}  />
                        </div>
					{this.state.action ? <div>
						<hr style={{margin:'25px'}} />
						<div style={{margin:'25px', fontWeight: 'bold'}}>About You</div>
						<div style={{ display: 'flex', flexFlow: 'row wrap', overflow: 'auto' }}>
							 
							 
							 <div key="37" className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="number" pattern="[0-9]*" inputmode="numeric" required value={this.state.npi} onChange={this.inputInfo('npi')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">Enter Your NPI</label>
                            </div>
							
							<div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="number" pattern="[0-9]*" inputmode="numeric" required value={this.state.mobile} onChange={this.inputNumber('mobile')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">Your Phone Number</label>
                            </div>
							
						</div>
						<hr style={{margin:'25px'}} />
						 <div  style={{margin:'25px', fontWeight: 'bold'}}>About the Patient</div>
                        <div style={{ display: 'flex', flexFlow: 'row wrap', overflow: 'auto' }}>
							
							<div key="38" className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="text" required value={this.state.cin} onChange={this.inputInfo('cin')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">Patient’s CIN</label>
                            </div>
							
							<div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="text" required value={this.state.dob} onChange={this.inputDate('dob')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">Patient’s Date of Birth</label>
                            </div>
							
							<div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="number" pattern="[0-9]*" inputmode="numeric" required value={this.state.height} onChange={this.inputInfo('height')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">Patient's Height in Inches</label>
                            </div> 
							
							<div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="number" pattern="[0-9]*" inputmode="numeric" required value={this.state.weight} onChange={this.inputInfo('weight')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">Patient's Weight in Pounds</label>
                            </div> 
                        </div>
                        <hr style={{margin:'25px'}} />
						<div  style={{margin:'25px', fontWeight: 'bold'}}>Diagnosis and Prescription</div>
                        <div style={{ display: 'flex', flexFlow: 'row wrap', overflow: 'auto' }}>
                            
							 <div style={{ textAlign: 'center', flex: '1 0 95%' }}>What is the mode of Administration?</div>
							<ReactSuperSelect onChange={this.selectAdmin} closeOnSelectedOptionClick={false}  placeholder="Mode" style={{ flex: '1 0 95%', margin: '0px' }} dataSource={[{id: 'Feeding Tube', name: 'Feeding Tube' },{id: 'Oral', name: 'Oral' }]}  />
							
							{this.state.admin == 'Feeding Tube' ? <div style={{margin:'15px 15px 25px 15px', fontSize:'12px', flex: '1 0 95%'}}>Please note: The Diagnosis Code must be written on the script by the provider.</div> : '' }
							
							
							<div style={{ marginTop: '25px',textAlign: 'center', flex: '1 0 95%' }}>Is the Enteral formula being prescribed for an inborn-metabolic disease?</div>
							<ReactSuperSelect onChange={this.selectIMD} closeOnSelectedOptionClick={false}  placeholder="Yes/No" style={{ flex: '1 0 150px', margin: '0px' }} dataSource={[{id: 'Yes', name: 'Yes' },{id: 'No', name: 'No' }]}  />
						{this.state.imd == 'Yes' ? <div>
							<div style={{ marginTop:'25px', textAlign: 'center', flex: '1 0 95%' }}>Enter the diagnosis related to the Inborn Metabolic Disease. Do not include the decimal point. </div>
							
                            <div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
                                <input className="textInput" type="text" required value={this.state.diagnosis} onChange={this.inputInfo('diagnosis')} ></input>
                                <span className="inputBar"></span>
                                <label className="textLabel">Diagnosis Code</label>
                            </div> 
								</div> : ''}
							
							<div style={{ width: '100%', display: 'flex', flexFlow: 'row wrap', overflow: 'auto' }}>
								<div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
									<input className="textInput" type="number" pattern="[0-9]*" inputmode="numeric" required value={this.state.calories} onChange={this.inputInfo('calories')} ></input>
									<span className="inputBar"></span>
									<label className="textLabel">Daily Calories</label>
								</div> 
								
								<div className="snazzyInputBox" style={{ flex: '1 0 200px', padding: '10px 0px' }}>
									<input className="textInput" type="number" pattern="[0-9]*" inputmode="numeric" required value={this.state.refills} onChange={this.inputInfo('refills')} ></input>
									<span className="inputBar"></span>
									<label className="textLabel">Number of Refills</label>
								</div> 
							</div> 
							
							
							<br/>
							<div style={{margin: '25px'}}>If your responses are complete, click ‘Submit”. Once ‘Submit’ is selected, your responses cannot be changed. </div>
						</div>
				 </div>	:'' }
                        <div style={{ position: 'relative', padding: '1px', margin: '0px auto' }}>
                            {this.state.error ?
                                <div className="error" style={{ margin: '25px', backgroundColor: 'rgba(144,48,112,' + this.state.errorBg + ')' }}>{this.state.error}</div>
                                : ''}

                            {this.state.loading ?
                                <div className="loader"></div>
                                :
                                <div className="button" onClick={this.next}>Submit</div>
                            }
                        </div>
                    </div>
                </div>
            )
        } else if (this.state.step == 4) {
            return (
                <div className="App">
                    <div className="backdrop"></div>
                    <div className="loginBox" onKeyUp={this.checkEnter}>
                        <img src={logo} className="App-logo" alt="logo" />
                        <div style={{ lineHeight: '30px' }}>Thanks! Your information has been submitted successfully.</div>
						<br/>
						<div style={{ lineHeight: '30px' }}>The Prior Authorization Number is {this.state.paNumber}</div>
						<br/>
						<br/>
						<div className="button" onClick={this.startOver}>Request Another PA</div>
                    </div>
                </div>
            )
        }
    }
}
